namespace pixi_ui.component {
    import NineSlicePlane = PIXI.mesh.NineSlicePlane;
    import Texture = PIXI.Texture;

    export class NineSlice implements IComponent {
        public antialiasing: boolean;
        public dontScaleOnClick: boolean;
        public nineSlicePlane: NineSlicePlane;

        constructor(
            texture: Texture,
            nineSliceOffset: {
                top: number;
                right: number;
                bottom: number;
                left: number;
            }
        ) {
            this.nineSlicePlane = new NineSlicePlane(
                texture,
                nineSliceOffset.left,
                nineSliceOffset.top,
                nineSliceOffset.right,
                nineSliceOffset.bottom
            );
        }

        public attach(element: Element): void {
            this.nineSlicePlane.width = element.elementWidth;
            this.nineSlicePlane.height = element.elementHeight;
            element.addChild(this.nineSlicePlane);
        }

        public detach(element: Element): void {
            element.removeChild(this.nineSlicePlane);
        }

        public resize(element: Element): void {
            this.nineSlicePlane.width = element.elementWidth;
            this.nineSlicePlane.height = element.elementHeight;
        }
    }
}
